import { CreateOperationRequest, CreateOperationReply, ReadOperationsReply, OrderOperationsRequest } from "@/backend/express/controllers/operationController";
import { Client } from "./client";
import { ReadOperationReply, SaveBlockReply, SaveBlockRequest, UpdateOperationReply, UpdateOperationRequest } from "@/types/operationTypes";
import { FusaReply } from "@/types/replyTypes";

export class OperationController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  public async updateOperation(req: UpdateOperationRequest): Promise<UpdateOperationReply> {
    return this.client.update('/api/operations', req);
  }

  public async listOperationsByParentId(parentId: string): Promise<ReadOperationsReply> {
    return this.client.read(`/api/operations/parent/${parentId}`);
  }

  public async createOperation(req: CreateOperationRequest): Promise<CreateOperationReply> {
    return this.client.create('/api/operations', req);
  }

  public async deleteOperation(operationId: string): Promise<FusaReply> {
    return this.client.delete(`/api/operations/${operationId}`);
  }

  public async duplicateOperation(operationId: string): Promise<ReadOperationReply> {
    return this.client.create(`/api/operations/duplicate/${operationId}`, {});
  }

  public async orderOperations(req: OrderOperationsRequest): Promise<ReadOperationsReply> {
    return this.client.update(`/api/operations/order`, req);
  }

  public async saveOperationAsBlock(req: SaveBlockRequest): Promise<SaveBlockReply> {
    return this.client.create(`/api/operations/saveBlock`, req);
  }
}
